import { render, staticRenderFns } from "./MailSimulation.vue?vue&type=template&id=3b505250&"
import script from "./MailSimulation.vue?vue&type=script&lang=js&"
export * from "./MailSimulation.vue?vue&type=script&lang=js&"
import style0 from "./MailSimulation.vue?vue&type=style&index=0&id=3b505250&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports